// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAQEtxieQP86UpENGFsiXGoaG12QlDIn1M",
    authDomain: "o-shop-c0e98.firebaseapp.com",
    projectId: "o-shop-c0e98",
    storageBucket: "o-shop-c0e98.appspot.com",
    messagingSenderId: "521035525326",
    appId: "1:521035525326:web:f8631ce47010a8a09b749f",
    measurementId: "G-YZ6MWN9MMJ"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
